<template>
  <div class="scustomers">
    <div class="scroll_bx">
      <img
        v-for="(item, index) in list"
        :key="index"
        :src="require(`@/assets/users/${item}`)"
        class="user_icon"
        alt=""
      />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      customer_data: [
        "walmart@2x.png",
        "vic@2x.png",
        "bohai@2x.png",
        "naked@2x.png",
        "yuncong@2x.png",
        "guoda@2x.png",
        "chuanmeidaxue@2x.png",
        "ennead@2x.png",
        "zenlayer@2x.png",
        // 'xuanjikeji.png',
        "ruijie.png",
      ],
      list: [],
    };
  },
  created() {
    this.list = this.customer_data.concat(this.customer_data);
  },
};
</script>
<style lang="less" scoped>
.scustomers {
  width: 100%;
  overflow: hidden;
  position: relative;
  @keyframes wordsLoop {
    0% {
      transform: translateX(0);
      -webkit-transform: translateX(0);
    }
    100% {
      transform: translateX(-1108px);
      -webkit-transform: translateX(-1108px);
    }
  }
  @-webkit-keyframes wordsLoop {
    0% {
      transform: translateX(0);
      -webkit-transform: translateX(0);
    }
    100% {
      transform: translateX(-1108px);
      -webkit-transform: translateX(-1108px);
    }
  }
  .scroll_bx {
    background: #fff;
    width: fit-content;
    display: flex;
    align-items: center;
    height: 62px;
    justify-content: center;
    padding-left: 20px;
    padding-right: 20px;
    position: relative;
    -webkit-animation: wordsLoop 70s linear infinite;
    animation: wordsLoop 70s linear infinite;
    .user_icon {
      height: 30px;
      width: auto;
      margin-right: 20px;
    }
    .user_icon:last-of-type {
      margin-right: 0;
    }
  }
}
</style>
